import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
import newDateFromString from '../../shared/dateHelper';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

type AllowedFormatKeys = 'long' | 'short' | 'onlyTime' | 'shortWithDayOfWeek' | 'ymd';

const ALLOWED_FORMATS: Record<AllowedFormatKeys, string> = {
  long: 'Do MMMM YYYY[,] h:mma',
  short: 'Do MMM YYYY',
  shortWithDayOfWeek: 'ddd, D MMM YYYY',
  onlyTime: 'LT',
  ymd: 'YYYY-MM-DD'
};

// expecting iso8601 format, for example rails code Model.updated_at.utc.iso8601
const formatToUserTimeZone = (timeString: string | Date, format = 'long') => {
  return dayjs(typeof timeString === "string" ? newDateFromString(timeString) : timeString)
    .tz(userTimeZone)
    .format(ALLOWED_FORMATS[format as AllowedFormatKeys] ?? ALLOWED_FORMATS.short);
};

export const userTimeZone = (() => {
  return (
    document.querySelector('meta[name="user-timezone"]')?.getAttribute('value') || dayjs.tz.guess()
  );
})();

export default formatToUserTimeZone;
